export const HOUR_WIDTH = 200;
export const timestamp = (value) => {
  if (value === null || value === undefined || value === "") return NaN;
  if (typeof value === "number" || /^\d+$/.test(value)) {
    const number = Number(value);
    return number < 1e12 ? number * 1000 : number;
  }
  return new Date(value).getTime();
};
export const programPlacement = (program, dayStart, dayEnd) => {
  const start = timestamp(
    program.startTime ?? program.starttime ?? program.begintime
  );
  const end = timestamp(program.endTime ?? program.endtime);
  if (
    !Number.isFinite(start) ||
    !Number.isFinite(end) ||
    end <= start ||
    end <= dayStart ||
    start >= dayEnd
  )
    return null;
  const clippedStart = Math.max(dayStart, start);
  const clippedEnd = Math.min(dayEnd, end);
  return {
    start,
    end,
    left: ((clippedStart - dayStart) / 3600000) * HOUR_WIDTH,
    width: ((clippedEnd - clippedStart) / 3600000) * HOUR_WIDTH
  };
};
export const searchChannels = (channels, term) => {
  const query = term.trim().toLocaleLowerCase("tr-TR");
  return channels.filter(
    (channel) =>
      !query || (channel.name || "").toLocaleLowerCase("tr-TR").includes(query)
  );
};
